const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/dashboard/validators/action-validators.js